var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinishError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 81.4166C41.3059 81.4166 28.5834 68.6941 28.5834 53C28.5834 37.3059 41.3059 24.5833 57 24.5833C72.6941 24.5833 85.4167 37.3059 85.4167 53C85.4167 68.6941 72.6941 81.4166 57 81.4166ZM57 76.25C69.8407 76.25 80.25 65.8406 80.25 53C80.25 40.1594 69.8407 29.75 57 29.75C44.1594 29.75 33.75 40.1594 33.75 53C33.75 65.8406 44.1594 76.25 57 76.25ZM47.0793 63.7458C47.8604 64.5269 49.1267 64.5269 49.9077 63.7458L55.5859 58.0676C56.367 57.2865 57.6333 57.2865 58.4144 58.0676L64.0926 63.7458C64.8736 64.5269 66.14 64.5269 66.921 63.7458L67.746 62.9209C68.527 62.1398 68.527 60.8735 67.746 60.0924L62.0678 54.4142C61.2867 53.6332 61.2867 52.3668 62.0678 51.5858L67.746 45.9076C68.527 45.1265 68.527 43.8602 67.746 43.0791L66.921 42.2542C66.14 41.4731 64.8736 41.4731 64.0926 42.2542L58.4144 47.9324C57.6333 48.7134 56.367 48.7135 55.5859 47.9324L49.9077 42.2542C49.1267 41.4731 47.8604 41.4731 47.0793 42.2542L46.2543 43.0791C45.4733 43.8602 45.4733 45.1265 46.2543 45.9076L51.9326 51.5858C52.7136 52.3668 52.7136 53.6332 51.9326 54.4142L46.2543 60.0924C45.4733 60.8735 45.4733 62.1398 46.2543 62.9209L47.0793 63.7458Z",
    fill: "url(#paint0_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.583374,
    y: 0.583313,
    width: 112.833,
    height: 112.833,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.027451 0 0 0 0 0.0784314 0 0 0 0 0.188235 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 57,
    y1: 24.5833,
    x2: 57,
    y2: 81.4166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B50A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F0207"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishError);
export default __webpack_public_path__ + "static/media/finish-error.11964280b8c445cb637d1a8514d11ff5.svg";
export { ForwardRef as ReactComponent };